import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { TrendingUp, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const ImproveRequests = () => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/improve-requests").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const close = async (id) => {
    try { await api.put(`/improve-requests/${id}`, { status: "done" }); setItems((l) => l.filter((x) => x.id !== id)); toast.success("Request closed"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!items.length) return null;
  return (
    <section className="rounded-xl border border-amber-400/40 bg-amber-400/5 p-6 mb-8 space-y-3" data-testid="improve-requests">
      <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-amber-300"><TrendingUp className="h-5 w-5" />Score improvement requests <span className="num text-sm px-2 rounded-full bg-amber-400/20">{items.length}</span></h2>
      {items.map((r) => (
        <div key={r.id} className="rounded-lg border border-slate-800 bg-slate-950/50 p-4 flex flex-wrap items-start gap-4" data-testid={`improve-request-${r.id}`}>
          <div className="flex-1 min-w-[240px]">
            <p className="font-semibold">{r.study_name} <span className="text-sm font-normal text-slate-400">· {r.client_name} · score <span className="num">{r.score}</span></span></p>
            {r.note && <p className="text-sm text-slate-400 mt-1">“{r.note}”</p>}
            <p className="text-xs text-slate-500 mt-1">{r.created_at?.slice(0, 10)}. The client is emailed automatically when you apply improvements.</p>
          </div>
          <div className="flex gap-2">
            <Button size="sm" data-testid={`improve-request-open-${r.id}`} onClick={() => navigate(`/studies/${r.study_id}?improve=1`)} className="rounded-full bg-amber-400 text-amber-950 hover:bg-amber-300"><TrendingUp className="h-4 w-4 mr-1" />Open study and improve</Button>
            <Button size="sm" variant="ghost" data-testid={`improve-request-close-${r.id}`} onClick={() => close(r.id)}><Check className="h-4 w-4 mr-1" />Close</Button>
          </div>
        </div>
      ))}
    </section>
  );
};
